/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RoomStatusCount = {
    properties: {
        status: {
    type: 'string',
    isRequired: true,
},
        count: {
    type: 'number',
    isRequired: true,
},
    },
};